export default {
  'build.info': 'פרטי בנייה',
  'build.mode': 'מצב',
  'build.framework': 'מסגרת עבודה',
  'build.os': 'מערכת הפעלה',
  'build.osPlatform': 'פלטפורמה',
  'build.osRelease': 'גרסה',
  'theme.light': 'בהיר',
  'theme.dark': 'כהה',
  'theme.system': 'מערכת',
  'theme.tooltip': 'ערכת נושא',
};
